import { Injectable, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '@cradua/domain';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class AuthenticationService{

    @Output() loggedInUser: EventEmitter<User> = new EventEmitter<User>();
	@Output() isAuthenticated: EventEmitter<boolean> = new EventEmitter<boolean>();
	isLoggedIn$: BehaviorSubject<boolean> = new BehaviorSubject(false);
	constructor(private myRoute: Router) {}
	sendToken(token: string) {
		localStorage.setItem('LoggedInUser', token);
	}
	getToken() {
		// this.localStorage.getItem('LoggedInUser').subscribe((user) => {
		//   if (user != null) {
		//     //user.firstName;
		//   }
		// }, () => {});
		return localStorage.getItem('LoggedInUser');
	}
	isLoggednIn() {
		return this.getToken() !== null;
	}
	logout() {
		localStorage.removeItem('LoggedInUser');
		//localStorage.removeItem('Company');
		//this.getUser();
		
		this.myRoute.navigate([ '/login' ]);
	}

	

	getUser(): User {
		
		let user: any = JSON.parse(localStorage.getItem('LoggedInUser'));
		

		if (user) {
			//console.log("User gotten ", user.user );
		this.loggedInUser.emit(user.user);
			this.isAuthenticated.emit(true);
			return user.user;
		} else {
			this.isAuthenticated.emit(false);
		}

		//console.log("User Gotten ", user);
		return user;
	}
}